module.exports = __webpack_public_path__ + "3000860ac585a6d7e2b50dd254a7d782.svg";